
export default async function() {
    if (flashes) {
        for (const [type, value] of Object.entries(flashes)) {
            if (typeof value === 'string') {
                // duration is defined by message type default
                await openAlert(value, type)
            } else {
                for (let text of value) {
                    await openAlert(text, type)
                }
            }
        }
        window.flashes = []
    }
}

